<!--
  This is for finding a restaurant via places api search
  selected restaurant is checked against our internal database
  options are then given to add if not there or use if it is.

-->

<script setup>
import { ref } from 'vue'
import restaurntPin1 from '@/assets/images/maps/restaurant-waiter-icon.svg'
import { useReservationsStore, useRestaurantsStore, useUsersStore } from "@/stores"
import {
  emailValidator,
  requiredValidator,
} from '@validators'

import { useRoute } from "vue-router"

import logo from '@/assets/logo.svg'

const emit = defineEmits([
  'update:isDialogVisible',
  'confirm',
  'cancel'
])
const route = useRoute()
const router = useRouter()

const showingDialog = ref(true)

const usersStore = useUsersStore()
let myUser = null;
({ myUser } = storeToRefs(usersStore))

const restaurantsStore = useRestaurantsStore()
let viewingDetailsRestaurant = null
let viewingDetailsRestaurantTab = null;
({ viewingDetailsRestaurant, viewingDetailsRestaurantTab } = storeToRefs(restaurantsStore))
</script>

<template>
  <VDialog
    v-if="viewingDetailsRestaurant"
    v-model="showingDialog"
    :width="$vuetify.display.mdAndDown ? '100%' : 650"
    :z-index="3001"
    persistent
    fullscreen
    no-click-animation
    :retain-focus="false"
  >
    <VCard class="">
      <VToolbar density="compact">
        <div class="toolbar-headline">
          <span class="ml-4 flex">
            <VImg
              :src="logo"
              height="40"
              width="40"
            />
          </span>
          <!--          <span class="headline-title">Preferred Reservations</span> -->
        </div>
        <VSpacer />
        <VToolbarItems>
          <VBtn
            icon="$close"
            size="large"
            variant="text"
            @click="viewingDetailsRestaurant = false"
          >
            <VIcon>mdi-close</VIcon>
          </VBtn>
        </VToolbarItems>
      </VToolbar>

      <div class="ml-2 mr-2">
        <RestaurantProfile
          :restaurant="viewingDetailsRestaurant"
          :start-at-tab="viewingDetailsRestaurantTab"
        />
      </div>
      <div class="d-flex flex-column align-center justify-center">
        <p
          class="rm-footer-message text-center text-wrap mt-4 pa-4"
          style="white-space: normal; max-width: 460px;font-size: 12px;"
        >
          Network of Artists, Athletes, CEOs, Investors &amp; Restaurateurs who highly value where they dine
        </p>
      </div>
      <!--
        <div class="d-flex flex-column align-center justify-center">
        <p class="text-center text-caption">
        <RouterLink
        class="text-primary"
        :to="{ path: '/members' }"
        >
        Members
        </RouterLink>&nbsp;&nbsp;|&nbsp;
        <RouterLink
        class="text-primary"
        :to="{ path: '/restaurants' }"
        >
        Restaurants
        </RouterLink>
        </p>
        </div> 
      -->
    </VCard>
  </VDialog>
</template>

<style scoped>
.no-outline {
  outline: none;
}

.toolbar-headline {
  display: flex;
  align-items: center;
  gap: 0.6rem;
}

.headline-title {
  font-family: var(--heading-font);
  font-weight: 400;
  color: var(--ds-text-strong);
  font-size: 1.4rem;
  line-height: 1em;
}
</style>
